import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, ButtonGroup, Col, Form, Image, Modal, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {cleanSpace, isEmpty, isResponseOk} from "enqc-utilities/src/utils/Utilities";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode, faWindowClose} from "@fortawesome/free-solid-svg-icons";
import {withRouter} from 'react-router-dom';
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import NumberInput from "./input/NumberInput";

class CreateAssemblyModal extends BaseComponent{


    constructor(props) {
        super(props);
        this.referenceInputRef = React.createRef();
        let {show, model} = this.props
        if(isEmpty(model)){
            model = {}
        }
        let validation = this.defaultValidation()
        let validationMessage = this.defaultValidationMessage()
        this.state = {
            show:show,
            model:model,
            reference:"",
            validation:validation,
            validationMessage:validationMessage,
            hideKeyboard:true,
        }
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {show, model} = nextProps
            this.setState({show, reference:'', model}, () => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    defaultValidation = () =>{
        let validation = {};
        validation.reference = true ;
        return validation ;
    }
    defaultValidationMessage = () =>{
        let validationMessage = {};
        validationMessage.reference = ""
        return validationMessage ;
    }

    componentDidMount() {
        super.componentDidMount();
        if(this.referenceInputRef && this.referenceInputRef.current){
            this.referenceInputRef.current.focus()
        }
    }

    async submit(){
        let {reference, model, validation, validationMessage} = this.state
        let valid = true ;
        if(isEmpty(reference)){
            validation.reference = false
            validationMessage.reference = label.EnterReference
            valid = false
        }
        if(!valid){
            this.setState({validation, validationMessage})
        }else{
            this.showPostProgress()
            let params = {}
            params.referenceCode = reference
            this.get(Endpoint.API.ASSEMBLY_VALIDATE_REFERENCE, {params:params},
                null, (res)=>{
                this.closePostProgress()
                if(isResponseOk(res)){
                        this.props.onResult(reference, model)
                    }
                }, false, true)
        }
    }

    render() {
        let {show, reference, validation, validationMessage, hideKeyboard} = this.state
        return (
            <>
                {super.render()}
                <Modal
                    as={Modal.Dialog}
                    size="md"
                    centered
                    show={show}
                    onHide={()=>{}}
                    onShow={()=>{
                        if(this.referenceInputRef && this.referenceInputRef.current){
                            this.referenceInputRef.current.focus()
                        }
                    }}>
                    <Modal.Header className="bg-warning">
                        <Row className="p-0 m-0 d-block w-100">
                            <Col className="p-0 m-0 text-center d-block">
                                <h4 className="p-0 m-0 text-center d-block">{label.CreateNewAssembly}</h4>
                            </Col>
                        </Row>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <Row className="p-3">
                            <Col className="text-center">
                                <Image className="w-50" src={ApplicationIcons.Icons.conveyorBelt}/>
                            </Col>
                        </Row>
                        <Row className="ps-3 pe-3 fs-6">
                            <Col className="text-center">
                                <span className="text-danger">
                                    {label.ANewAssemblyWillBeGeneratedWithTheReferenceCodeYouProvided_PleaseKindlyTakeItIntoConsideration}
                                </span>
                            </Col>
                        </Row>
                        <hr className="mt-2 mb-2"/>
                        <Row className="p-3">
                            <Col sm={12} md={12} className="fs-7 text-center">
                                {label.ReferenceCodeFormatYYYYFollowingWith6RunningNumbers}
                            </Col>
                            <Col sm={12} md={12}>
                                <Form>
                                    <NumberInput
                                        required={true}
                                        placeholder={label.EnterReference}
                                        rows={4}
                                        value={reference}
                                        centered={true}
                                        style={{height:'52px', fontSize:'32px', fontWeight:'bold'}}
                                        onClick={() => {
                                            this.setState({hideKeyboard:false})
                                        }}
                                        onChange={(value) => {
                                            value = cleanSpace(value)
                                            reference = value
                                            validation.reference = true
                                            validationMessage.reference = ""
                                            this.setState({reference, validation, validationMessage})
                                        }}
                                        onEnter={(value) => {
                                            value = cleanSpace(value)
                                            reference = value
                                            validation.reference = true
                                            validationMessage.reference = ""
                                            this.setState({reference, validation, validationMessage}, async () => {
                                                await this.submit()
                                            })
                                        }}
                                        ref={this.referenceInputRef}
                                        autoFocus={true}
                                        maxLength={10}
                                        danger={true}
                                        readOnly={hideKeyboard}
                                        isError={!validation.reference}
                                        errorMessage={validationMessage.reference}
                                    />
                                </Form>
                            </Col>
                        </Row>
                        <hr className="m-0"/>
                        <Row className="p-3">
                            <Col className="text-right">
                                <ButtonGroup>
                                    <Button
                                        size="sm"
                                        variant="info"
                                        onClick={async (event) => {
                                            this.props.onClose()
                                        }}>
                                        {label.Cancel}&nbsp;&nbsp;<FontAwesomeIcon icon={faWindowClose}/>
                                    </Button>
                                    &nbsp;
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={async (event) => {
                                            await this.submit()
                                        }}>
                                        {label.Submit}&nbsp;&nbsp;<FontAwesomeIcon icon={faCode}/>
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
CreateAssemblyModal.propTypes = {
    show:PropTypes.bool.isRequired,
    model:PropTypes.object,
    onClose:PropTypes.func.isRequired,
    onResult:PropTypes.func.isRequired
}

export default withRouter(CreateAssemblyModal)
